import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { ListBase } from 'src/app/components/core/_infrastructure/classes/listBase';
import { Table } from 'primeng/table';
import { FilterSearchingBaseViewModel } from 'src/app/components/core/_infrastructure/types/common';
import { UserDataViewModel } from '../../../buscadores/solicitudes/buscador-solicitud-cam.types';
import {
    RecintoUnidadInspeccionItemResultsViewModel,
    FilterSearchingRecintoUnidadInspeccion,
    RecintoUnidadInspeccionItemViewModel,
} from '../../../buscadores/unidades-inspeccion/buscador-unidad-inspeccion.types';
import { EnumTcEstadoUnidadInspeccion } from '../../../types/enum';

@Component({
    selector: 'app-selector-unidad-inspeccion-list',
    templateUrl: './selector-unidad-inspeccion-list.component.html',
    styleUrls: ['./selector-unidad-inspeccion-list.component.scss'],
})
export class SelectorUnidadInspeccionListComponent extends ListBase implements OnInit, OnChanges {
    @Input() result: RecintoUnidadInspeccionItemResultsViewModel;
    @Input() lastFilter: FilterSearchingRecintoUnidadInspeccion;
    @Input() userData: UserDataViewModel;
    @Input() title: { plural: string; singular: string };
    @Output() search = new EventEmitter<FilterSearchingBaseViewModel>();
    @Output() view = new EventEmitter<RecintoUnidadInspeccionItemViewModel>();
    @Output() selectedRecintosUI = new EventEmitter<any>();

    @ViewChild('tableSearch') turboTable: Table;

    cols: any[];
    SIN_ASIGNAR = EnumTcEstadoUnidadInspeccion.SIN_ASIGNAR;
    arraySelectedRecintosUI: RecintoUnidadInspeccionItemViewModel[] = [];

    constructor(protected notificacionService: NotificationService) {
        super(notificacionService);
    }

    ngOnInit() {
        this.initCols();
        this.loading = true;
    }

    private initCols(): void {
        this.cols = [
            { field: 'ExpandLink', header: '', reduce: true },
            { field: 'Link', header: '', reduce: true },
            { field: 'Image', header: '', reduce: true },
            { field: 'IdUi', header: 'Id', display: 'none' },
            { field: 'CodigoUhc', header: 'Cod. Ud. Insp.' },
            { field: 'Campania', header: 'Campaña' },
            { field: 'Periodo', header: 'Periodo' },
            { field: 'TipoSolicitud', header: 'Tipo Recinto' },
            { field: 'DescripcionComunidad', header: 'Com. Aut.' },
            { field: 'EntidadAuditora', header: 'Entidad Auditora' },
        ];

        this.initSelection();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.result?.currentValue) {
            this.result = { ...changes.result.currentValue };
            this.loading = false;
            setTimeout(() => {
                if (this.turboTable) {
                    this.turboTable.sortOrder = this.lastFilter?.Asc;
                    this.turboTable.sortField = this.lastFilter?.OrderBy;
                    this.turboTable.first = this.lastFilter?.PageNumber * this.result?.PageSize;
                }
            }, 100);
        }
    }

    /**
     * Hay que borrar los datos obtenidos, ya que perduran.
     * Para que al entrar la siguiente vez, no salgan marcados los checkbox en la tabla
     */
    private initSelection(): void {
        this.arraySelectedRecintosUI.splice(0, this.arraySelectedRecintosUI.length);
    }

    onSearchLazy(event: any): void {
        if (!event.rows || event.sortField === 'Link' || event.sortField === 'Image') {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.loading = true;

        const f: FilterSearchingBaseViewModel = {
            PageNumber: pageNumber,
            Asc: event.sortOrder,
            OrderBy: event.sortField || '',
        };

        this.search.emit(f);
    }

    onView(item: RecintoUnidadInspeccionItemViewModel): void {
        this.view.emit(item);
    }

    /**
     * @param $event Event
     * @param rowData RecintoUnidadInspeccionItemViewModel
     */
    onSelect($event: any, rowData: any): void {
        // rowData is ignored, because the proper values are at arraySelectedRecintos
        let arraySelected = this.arraySelectedRecintosUI.slice(); // Devuelve una copia del array.
        this.selectedRecintosUI.emit(arraySelected);
    }

    /**
     * This event is used only when in dialogMode.
     * It will have to tell which kind of selection the user has made.
     * The data selected will be raised alongside the type of selection.
     *
     * A partir de los cultivos seleccionados en la lista de recintos-cultivos,
     * se crea una lista nueva que contiene el recinto y dentro de su propiedad TwCultivoCollection, solo sus cultivos seleccionados.
     * Esto se hace así, porque se ha asociado el cultivo al checkbox.
     * Si se asociara el recinto entero al checkbox, la selección contendría el recinto y todos sus cultivos,
     * independientemente de que solo se seleccionara uno, de ahí que no valga la solución sencilla que se ha implementado en otros componentes.
     *
     * La lista de recintos-cultivos así compuesta se emite por evento para su procesamiento en el componente subscriptor.
     * @param $event Event
     * @param rowData RecintoUnidadInspeccionItemViewModel
     * @param cultivo CultivoViewModel
     */
    /*
    onSelect($event: any, rowData: RecintoUnidadInspeccionItemViewModel, cultivo: CultivoViewModel): void {
        // cultivo is ignored, because the proper values are at _selection

        const cultivosSeleccionados: CultivoViewModel[] = this.turboTable?._selection;
        const IdsCultivosSeleccionados = cultivosSeleccionados?.map(cultivo => cultivo.Id); // obtenemos los Ids de los cultivos seleccionados.
        let recintosCultivos: RecintoUnidadInspeccionItemViewModel[] = [];
        let contadorCultivosProcesados = 0;

        this.result.ResultList.forEach((recinto: RecintoUnidadInspeccionItemViewModel) => {
            if (!recinto) return;
            if (contadorCultivosProcesados === IdsCultivosSeleccionados.length) {
                // Optimización para evitarnos continuar si ya se han añadido todos los cultivos seleccionados.
                return; // Next iteration in the loop
            }
            recinto.TwCultivoCollection?.forEach((cultivo: CultivoViewModel) => {
                let nuevoRecinto: RecintoUnidadInspeccionItemViewModel | undefined;

                // Vamos creando una lista con los recintos-cultivos seleccionados.
                // Si dado un cultivo, su recinto ya hubiera sido añadido a la lista, entonces añadimos el cultivo a su lista de cultivos.
                if (IdsCultivosSeleccionados.find(id => id === cultivo.Id) === null) {
                    return; // Next iteration in the loop
                }
                if (recintosCultivos?.length > 0 && recintosCultivos.find(recinto => recinto.Id === cultivo.IdRecinto)) {
                    nuevoRecinto = recintosCultivos.find(recinto => recinto.Id === cultivo.IdRecinto);
                } else {
                    nuevoRecinto = { ...recinto };
                    nuevoRecinto.TwCultivoCollection = [];
                }
                nuevoRecinto!.TwCultivoCollection?.push({ ...cultivo });
                contadorCultivosProcesados++;
                recintosCultivos.push(nuevoRecinto!);
            });
        });
        this.selectedRecintosUI.emit(recintosCultivos);
    }
    */
}
